import Player from "lottie-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import animationData from "@src/assets/lottie/Warning.json";
import Container from "@src/components/shared/Container";
import TitleAndDesc from "@src/components/shared/TitleAndDesc";
import { Button } from "@src/components/ui/button";
import useZustandStore from "@src/helpers/zustand";
import { getErrorUrl } from "@src/utils/consts";
import { useLocation } from "react-router-dom";

function ErrorPage() {
  const location = useLocation();
  const { data: zData, clearData } = useZustandStore((state) => state);
  const { t, i18n } = useTranslation();
  const { title, description, errorBtn } = location.state || {};

  useEffect(() => {
    clearData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <div className="py-6">
        <TitleAndDesc
          // desc={zData.errorMessage || t("error.desc")}
          title={title || t("error.title")}
        />
      </div>
      <div className="py-4 pl-8 pr-4 rounded-lg bg-whitebitBlueDark border border-solid border-whitebitYellow">
        <ul className="list-disc">
          {/* <li className="text-whitebitYellow text-sm">{t("error.list.1")}</li> */}
          <li className="text-whitebitYellow text-sm">
            {description || zData.errorMessage || t("error.desc")}
          </li>
        </ul>
      </div>
      <div className="flex flex-1 items-center justify-center max-md:min-h-[60vh]">
        <div className="mx-auto h-[180px] w-[180px]">
          <Player
            loop={false}
            autoplay={true}
            animationData={animationData}
            rendererSettings={{
              preserveAspectRatio: "xMidYMid slice",
            }}
          />
        </div>
      </div>
      {errorBtn == "hide" ? (
        <></>
      ) : (
        <div
          className="w-full self-end rounded-[6px] bg-white py-8
       max-md:absolute max-md:bottom-0 max-md:left-0 max-md:right-0 max-md:px-4"
        >
          <a className="w-full" href={getErrorUrl(i18n.language)}>
            <Button className="w-full">{t("back")}</Button>
          </a>
        </div>
      )}
    </Container>
  );
}

export default ErrorPage;
